import * as ActionTypes from './../constants';

export default (state={}, action) => {
    switch(action.type){
        case ActionTypes.REQUEST_CURRENT_AFFAIRS:
         return{
             ...state,
             loading:true,
             response: null
         }

        case ActionTypes.RECEIVED_CURRENT_AFFAIRS:
            return{
                ...state,
                loading:false,
                response: action.res && action.res,                
            }
        case ActionTypes.ERROR_CURRENT_AFFAIRS:
            return{
                ...state,
                loading:false,
                err: true,
                errorInfo: action.err,
                response:null,
            }
        case ActionTypes.REQUEST_FULL_CONTENT_DESCRIPTION:
            return {
                ...state,
                fullDescriptionLoading: true,
                fullDescriptionError: false,                

            }
        case ActionTypes.RECEIVED_FULL_CONTENT_DESCRIPTION:
            return {
                ...state,
                fullDescriptionLoading: false,
                fullDescriptionError: false,
                fullDescriptionResponse: action.fullDescriptionResponse,
            }
        case ActionTypes.ERROR_FULL_CONTENT_DESCRIPTION:
            return {
                ...state,
                fullDescriptionError: true,
                fullDescriptionErrInfo: action.fullDescriptionErrInfo,
                fullDescriptionLoading: false,
                fullDescriptionResponse: null
            }
        case ActionTypes.CLEAR_FULL_CONTENT_DESCRIPTION: 
            return {
                ...state,
                fullDescriptionResponse: null
            }
        case ActionTypes.CLEAR_CURRENT_AFFAIRS:
            return{}
            
        default: return state

    }
}